import React, { useState, useEffect } from "react";
import PropTypes from 'prop-types';
import { Dropdown, DropdownToggle, DropdownMenu, DropdownItem, } from "reactstrap";
import { useSelector } from "react-redux";
//i18n
import { withTranslation } from "react-i18next";
// Redux
import { connect } from "react-redux";
import { Link } from "react-router-dom";
import withRouter from "../withRouter";

// users
import user1 from "../../../assets/images/users/avatar-2.webp";
// import { set } from "lodash";

const ProfileMenu = props => {
  // Declare a new state variable, which we'll call "menu"
  const [menu, setMenu] = useState(false);

  const [username, setusername] = useState("Admin");
  const [userImage, setuserImage] = useState(user1);
  const profileTrigger = useSelector(state => state.profileTrigger.trigger);

  // const [role, setrole] = useState("");
  useEffect(() => {
    if (localStorage.getItem("authUser")) {
      if (process.env.REACT_APP_DEFAULTAUTH === "firebase") {
        const obj = JSON.parse(localStorage.getItem("authUser"));
        setusername(obj.displayName);
        setuserImage(obj.userImage);
        // setrole(obj.role);
      } else if (
        process.env.REACT_APP_DEFAULTAUTH === "fake" ||
        process.env.REACT_APP_DEFAULTAUTH === "jwt"
      ) {
        const obj = JSON.parse(localStorage.getItem("authUser"));
        setusername(obj?.response?.firstName);
        setuserImage(obj?.response?.avatar);
        // setrole(obj.role);

        const updatedResponse = { ...obj.response };
let shouldUpdate = false;

if (updatedResponse.avatar !== obj.response.avatar) {
  updatedResponse.avatar = obj.response.avatar;
  shouldUpdate = true;
}

const fieldsToSync = ["firstName", "lastName", "email", "mobile"];
for (const key of fieldsToSync) {
  if (updatedResponse[key] !== obj.response[key]) {
    updatedResponse[key] = obj.response[key];
    shouldUpdate = true;
  }
}

if (shouldUpdate) {
  const newAuthUser = { ...obj, response: updatedResponse };
  localStorage.setItem("authUser", JSON.stringify(newAuthUser));
}

      }
    }
}, [props.success, profileTrigger]);
  return (
    <React.Fragment>
      <Dropdown
        isOpen={menu}
        toggle={() => setMenu(!menu)}
        className="d-inline-block"
      >
        <DropdownToggle
          className="btn header-item "
          id="page-header-user-dropdown"
          tag="button"
        >
          <img
            className="rounded-circle header-profile-user"
            src={userImage || "https://res.cloudinary.com/harshdubey1198/image/upload/v1759746422/user_mw69nd.png"}
            alt="Header Avatar"
          />
          {/* <span className="d-none d-xl-inline-block ms-2 me-2">{username}</span> */}
          {/* <i className="mdi mdi-chevron-down d-none d-xl-inline-block" /> */}
        </DropdownToggle>
        <DropdownMenu className="dropdown-menu-end">
          {/* username show here */}
          <DropdownItem className="text-center p-0" disabled>
            <span className="text-primary" style={{fontSize:"14px" , fontWeight:"600"}} >{username}</span>
          </DropdownItem>
          <div className="dropdown-divider" />
          <DropdownItem >
            <Link to="/profile-settings" className="dropdown-item my-0 px-0">
            {" "}
            <i className="ri-user-line align-middle me-2" />
            {props.t("Profile")}{" "}
            </Link>
          </DropdownItem>
          <DropdownItem tag="a" href="auth-lock-screen">
            <i className="ri-lock-unlock-line align-middle me-2" />
            {props.t("Lock screen")}
          </DropdownItem>
          <div className="dropdown-divider" />
          <Link to="/logout" className="dropdown-item">
            <i className="ri-shut-down-line align-middle me-2 text-danger" />
            <span>{props.t("Logout")}</span>
          </Link>
        </DropdownMenu>
      </Dropdown>
    </React.Fragment>
  );
};

ProfileMenu.propTypes = {
  success: PropTypes.any,
  t: PropTypes.any
};

const mapStatetoProps = state => {
  const { error, success } = state.profile;
  return { error, success };
};

export default withRouter(
  connect(mapStatetoProps, {})(withTranslation()(ProfileMenu))
);
